export const messages = {
  expandAltText: {
    id: 'authoring.videoeditor.expand',
    defaultMessage: 'Expand',
  },
  collapseAltText: {
    id: 'authoring.videoeditor.collapse',
    defaultMessage: 'Collapse',
  },
  validateErrorTitle: {
    id: 'authoring.videoeditor.validate.error.title',
    defaultMessage: 'We couldn\'t add your video.',
    description: 'Title of validation error.',
  },
  validateErrorBody: {
    id: 'authoring.videoeditor.validate.error.body',
    defaultMessage: 'Please check your entries and try again.',
    description: 'Body of validation error.',
  },
};

export default messages;
